const STORAGE = {
  showroomLocation: 'KIASHOWLOC',
  showroomScene: 'KIASHOWSCENE',
  showInfo: 'KIASHOWINFO',
  dealer: 'KIADEALER',
};

export default STORAGE;
